import React from 'react';

import classes from './Services.css';
import Spacer from '../../../components/Spacer/Spacer';
import Block from '../../../components/BlockContent/Services/Block';
import Section from '../../../hoc/Section/Section';
import ParallaxImage from '../../../components/ParallaxImage/ParallaxImage';
import BannerItems from '../../../components/Banner/BannerItems';
import Citation from '../../../components/Citation/Citation';

import AgileImg from '../../../assets/images/agile.svg';
import ProjectImg from '../../../assets/images/project.svg';
import ArchitectureImg from '../../../assets/images/architecture.svg';
import WebImg from '../../../assets/images/laptop.svg';
import MobileImg from '../../../assets/images/phone.svg';
import UXUI from '../../../assets/images/uxui.svg';
import Img12 from '../../../assets/images/img12.png';
import Img16 from '../../../assets/images/img16.jpg';
import Img17 from '../../../assets/images/img17.jpg';
import Img19 from '../../../assets/images/img19.jpg';
import Img20 from '../../../assets/images/img20.jpg';
// import AgileBackground from '../../assets/images/agileBg.svg';
// import ProjectBackground from '../../assets/images/projectBg.svg';
// import ArchitectureBackground from '../../assets/images/architectureBg.svg';
// import WebBackground from '../../assets/images/webBg.svg';
// import MobileBackground from '../../assets/images/mobileBg.svg';
// import Waterfall from '../../assets/images/waterfall.svg';
// import People from '../../assets/images/people.svg';
// import Asp from '../../assets/images/aspnet.svg';
// import Netcore from '../../assets/images/netcore.svg';
// import ReactImg from '../../assets/images/react.svg';
// import Javascript from '../../assets/images/js.svg';
// import Xamarin from '../../assets/images/xamarin.svg';
// import CrossPlatform from '../../assets/images/crossplatform.svg';
// import Responsive from '../../assets/images/responsive.svg';
// import Agilecoaching from '../../assets/images/agile_coaching.svg';

const services = (props) => {

    return (
        <div key="services" className={classes.Main} id="services">

            <div className={classes.SkillDiv} style={{color: props.color}}>
                <div className={classes.SkillTitle} style={{color: "white", position:"relative", top:0, left:0}} data-clippath={classes.SwitchColor}>
                    <ParallaxImage >
                        <img src={Img12} style={{width: "100%"}} alt=''/>
                    </ParallaxImage>
                    <Citation   author="Steve Jobs" 
                                style={{
                                    textAlign: "right", 
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)"
                                    }}>
                        Technology is nothing. What’s important is that you have a faith in people, 
                        that they’re basically good and smart, and if you give them tools, 
                        they’ll do wonderful things with them.
                    </Citation>
                </div>

                <Section link="/#services" mainSection="/#services"/>

                <Spacer height="50px" />

                <BannerItems isMobile={props.isMobile}/>

                <Spacer height="50px" />

                <div className={classes.Title}>
                    <h1 id="whatwedo">Our Practice Areas</h1>
                    <div style={{width:"30%", margin: "auto", height:"1px", background: props.color}}></div>
                </div>

                <Spacer height="50px" />

                <div className={classes.SkillOverview}>
                    
                    <Block 
                        image={Img16}
                        logo={AgileImg}
                        link={"/#agileservices"}
                        mainSection={"/#services"}
                        imageColor={"lightgray"}
                        skills={["Lean", "Scrum", "Kanban", "SAFe"]}
                        title={"Agile Services"}>
                        
                        <p>Be flexible and faster with Agile project management</p>
                    </Block>

                    <Block 
                        image={Img17} 
                        logo={ProjectImg}
                        link={"/#projectmanagement"}
                        mainSection={"/#services"}
                        imageColor={"lightgray"}
                        skills={["Waterfall", "V Cyle", "Prince2", "Agile"]}
                        title={"Project Management"}>
                        
                        <p>Let us follow you all along your project to ensure a success story</p>
                    </Block>


                    <Block 
                        image={Img19} 
                        logo={UXUI} 
                        link={"/#design"}
                        mainSection={"/#services"}
                        imageColor={"lightgray"}
                        skills={["UI Design", "UX Design", "Content Analysis", "Graphic Design"]}
                        title={"Design"}>
                        
                        <p>Users centrics to bring the most valuable user experience by improving visual design, usability and users satisfaction</p>
                    </Block>

                    {/* <Block 
                        image={Img18} 
                        logo={ArchitectureImg} 
                        textColor={props.color}
                        imageColor={"lightgray"}
                        title={"Software Architecture"}>
                        
                        <p>Our expert will guide you through the entire modeling process of your application project by providing guidance regarding the perfect software architecture for your needs</p>    
                    </Block> */}

                    <Block 
                        image={Img20} 
                        logo={WebImg}
                        link={"/#development"}
                        mainSection={"/#services"}
                        imageColor={"lightgray"}
                        skills={["Web Development", "Mobile Development", "Front-End Development", "Back-End Development", "Application Hosting", "Serverless Apllication"]}
                        title={"Development"}>
                        
                        <p>Fully responsive application</p>
                        <p>Secured, highly avalaible, flexible and affordable application hosting</p>
                    </Block>

                    {/* <Block 
                        image={Img21} 
                        logo={MobileImg} 
                        textColor={props.color}
                        imageColor={"lightgray"}
                        title={"Mobile Development"}>
                        
                        <p>By using the last and industry leading technologies we are able to provide in one shot cross-platform appliactions to fit your needs</p>    
                    </Block> */}
                    
                </div>
            </div>
            
        </div>
    );
}

export default services;


// WEBPACK FOOTER //
// ./client/src/containers/Home/Services/Services.js